import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types';
import FormError from '../partials/FormError';
import { stopInspection } from '../../actions/inspections';
import { resetQuestionsState } from '../../actions/questions';
import { validateCommaEmails } from '../../helpers/validation';
import { destructServerErrors, allErrors } from '../../helpers/error';
import __ from '../../helpers/translation';

const propTypes = {
  inspection: PropTypes.object.isRequired,
};

function StopReportModal(props) {
    //console.log(props);
    const dispatch = useDispatch()

    const [isStoping, setIsStoping] = useState(false);
    const [sendByMail, setSendByMail] = useState(false);
    const [emails, setEmails] = useState('');
    const [errors, setErrors] = useState('');
    const [explanation, setExplanation] = useState('');

    useEffect(() => {
        return function cleanup() {
          window.$('.modal-backdrop').remove();
        };
    }, []);

    const endInspection = (generateReport) => {
      setIsStoping(true);
      setErrors('');
      dispatch(stopInspection(props.inspection.report, generateReport, emails, explanation))
        .then(() => {
          dispatch(resetQuestionsState());
        })
        .catch(error => {
          console.log(error);
          setErrors(error);
          setIsStoping(false);
        });
    }

    const stopWithReport = () => {
        if(!props.inspection.report.can_send_email){
            endInspection(true);
            return;
        }
        setSendByMail(true);
    }

    const generateAndSendViaMail = () => {
        if(!emails.length){
            endInspection(true);
            return;
        }

        if(!validateCommaEmails(emails)){
            setErrors(__('app.questions.send_inspection_input_emails_error'));
            return;
        }

        endInspection(true);
    }

    const stop = () => {
        endInspection(false);
    }

    return (
        <div className="modal fade" id="stopReport" tabIndex="-1" role="dialog" aria-labelledby="stopReport" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content p-3 p-sm-5">
                    <div className="modal-header">
                        <h1 className="modal-title fw-600">
                            { __('app.questions.stop_inspection_popup_title') }
                        </h1>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {errors && 
                            (
                                <FormError>{errors}</FormError>
                            )
                        }
                        {sendByMail ? 
                            (
                                <Fragment>
                                    <p>
                                        { __('app.questions.send_inspection_by_mail_message') }
                                    </p>
                                    <div className="form-group">
                                        <div className="form-label-group">
                                            <input name="emails" value={emails} onChange={(e) => setEmails(e.target.value)} type="text" className="form-control" placeholder={ __('app.questions.send_inspection_input_emails') } />
                                            <label htmlFor="emails">{ __('app.questions.send_inspection_input_emails') }</label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <textarea onChange={(e) => setExplanation(e.target.value)} value={explanation} name="explanation" className="form-control" id="explanation" cols="30" rows="4"></textarea>
                                        <label htmlFor="explanation">{ __('app.questions.stop_inspection_popup_explanation') }</label>
                                    </div>
                                    <button onClick={() => generateAndSendViaMail() }
                                    disabled={ isStoping }
                                    className="btn btn-success d-block w-100 mt-5">
                                        { __('app.questions.send_inspection_button') }
                                    </button>
                                </Fragment>
                            ) :
                            (
                                <Fragment>
                                    <p>
                                        { __('app.questions.stop_inspection_popup_message') }
                                    </p>
                                    <div className="form-group">
                                        <textarea onChange={(e) => setExplanation(e.target.value)} value={explanation} name="explanation" className="form-control" id="explanation" cols="30" rows="4"></textarea>
                                        <label htmlFor="explanation">{ __('app.questions.stop_inspection_popup_explanation') }</label>
                                    </div>
                                    <button onClick={() => stopWithReport() }
                                    disabled={ isStoping }
                                    className="btn btn-success d-block w-100 mt-5">
                                        { __('app.questions.stop_inspection_popup_button_generate') }
                                    </button>
                                    <button onClick={() => stop() }
                                    disabled={ isStoping }
                                    className="btn btn-outline-dark d-block mt-2 py-3 w-100">
                                        { __('app.questions.stop_inspection_popup_button_cancel') }
                                    </button>
                                </Fragment>
                            )
                        }
                       
                    </div>
                </div>
            </div>
        </div>
    );
  
}

StopReportModal.propTypes = propTypes;

export default StopReportModal;